import React, { useEffect, useState } from "react";
import { analyticsFunction } from "../../../lib/dataAnalytics/eventListener";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { cn } from "../../../helpers/cn";
import { useRouter } from "next/router";

interface IMobileStores extends React.ComponentProps<"div"> {
  width?: boolean | number;
  section?: boolean | number;
  alwaysColumnDirection?: boolean;
  useWhiteIcons?: boolean;
}

function MobileStores({
  width = false,
  section = false,
  alwaysColumnDirection = false,
  useWhiteIcons = false,
  className,
}: IMobileStores) {
  const theme = useSelector((state: RootState) => state.theme);
  const [mobileLinks, setMobileLinks] = useState({ apple: "", android: "" });
  const router = useRouter();

  const handleWindowSize = () => {
    if (router.asPath.includes("coach")) {
      setMobileLinks({
        apple: "https://apps.apple.com/ie/app/pod1um-coach/id6737241716",
        android:
          "https://play.google.com/store/apps/details?id=app.pod1um.coach",
      });

      return;
    }

    if (window.innerWidth < 1240) {
      setMobileLinks({
        apple: "https://pod1um.page.link/gBMb",
        android: "https://pod1um.page.link/gBMb",
      });

      return;
    }

    setMobileLinks({
      apple: "https://apps.apple.com/ie/app/pod1um/id1562663063",
      android: "https://play.google.com/store/apps/details?id=app.pod1um",
    });
  };

  useEffect(() => {
    handleWindowSize();

    window.addEventListener("resize", handleWindowSize);

    return () => window.removeEventListener("resize", handleWindowSize);
  }, []);

  return (
    <div
      className={cn(
        alwaysColumnDirection
          ? "flex flex-col space-y-4"
          : "flex flex-col space-y-7 lg:flex-row lg:space-y-0 lg:space-x-7",
        className,
      )}
    >
      {useWhiteIcons ? (
        <>
          <a href={mobileLinks.apple} target="_blank">
            <img
              src="/images/apple-white-icon.svg"
              alt="App Store"
              className={`my-auto cursor-pointer`}
              onClick={() => {
                analyticsFunction({
                  event: "select_content",
                  content_type: "android",
                  item_id: `Section ${section ? section.toString() : "0"}`,
                });
              }}
            />
          </a>

          <a href={mobileLinks.android} target="_blank">
            <img
              src="/images/google-white-icon.svg"
              alt="Play Store"
              className={`my-auto cursor-pointer`}
              onClick={() => {
                analyticsFunction({
                  event: "select_content",
                  content_type: "Apple",
                  item_id: `Section ${section ? section.toString() : "0"}`,
                });
              }}
            />
          </a>
        </>
      ) : (
        <>
          <Stack
            sx={{
              border: "1px solid",
              backgroundColor:
                theme.mode === "dark"
                  ? "transparent"
                  : theme.componentColors.surface.onSurface,
            }}
            className=" border rounded-lg border-gray-700 bg-gray-750 flex items-center justify-center px-3 pt-2"
          >
            <a href={mobileLinks.android} target="_blank">
              <img
                src="/images/google-play.svg"
                alt="Google play"
                className={`my-auto cursor-pointer ${
                  width ? `w-${width.toString()}` : "w-36"
                }`}
                onClick={() => {
                  analyticsFunction({
                    event: "select_content",
                    content_type: "android",
                    item_id: `Section ${section ? section.toString() : "0"}`,
                  });
                }}
              />
            </a>
          </Stack>

          <Stack
            sx={{
              border: "1px solid",
              backgroundColor:
                theme.mode === "dark"
                  ? "transparent"
                  : theme.componentColors.surface.onSurface,
            }}
            className="border rounded-lg border-gray-700  bg-gray-750 flex items-center justify-center px-3 pt-2"
          >
            <a href={mobileLinks.apple} target="_blank">
              <img
                src="/images/app-store.svg"
                alt="Google play"
                className={`my-auto cursor-pointer ${
                  width ? `w-${width.toString()}` : "w-36"
                }`}
                onClick={() => {
                  analyticsFunction({
                    event: "select_content",
                    content_type: "Apple",
                    item_id: `Section ${section ? section.toString() : "0"}`,
                  });
                }}
              />
            </a>
          </Stack>
        </>
      )}
    </div>
  );
}

export default MobileStores;
